import { render, staticRenderFns } from "./landingPageView.vue?vue&type=template&id=62e178d4&"
import script from "./landingPageView.vue?vue&type=script&lang=js&"
export * from "./landingPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports